import React from 'react'
import BookUsage from './usage'

export default ({ usedBy, checks, chapters, notes }) => {
  const errors = (checks && checks.errors) || []
  const warnings = (checks && checks.warnings) || []
  const success = checks ? checks.nb - warnings.length - errors.length : 0
  return (
    <aside className="diagnostic">
      {usedBy && Object.keys(usedBy).length > 0 && (
        <div className="usedBy">
          Utilisé par
          <ul>
            {Object.keys(usedBy).map(id => {
              return (
                <li key={id}>
                  <BookUsage chapterId={id} usages={usedBy[id]} chapters={chapters} />
                </li>
              )
            })}
          </ul>
        </div>
      )}
      {!checks && (
        <p className="diag-loading">
          <i className="fa fa-cog fa-spin fa-fw" /> Contrôle qualité en cours…
        </p>
      )}
      {checks && (
        <div className="diag-summary">
          {success > 0 && (
            <span className="diag-pill diag-ok" title="vérifications réussies">
              <i className="fa fa-check" /> {success}
            </span>
          )}
          {warnings.length > 0 && (
            <span className="diag-pill diag-warn" title="avertissements">
              <i className="fa fa-exclamation-triangle" /> {warnings.length}
            </span>
          )}
          {errors.length > 0 && (
            <span className="diag-pill diag-error" title="erreurs">
              <i className="fa fa-times-circle" /> {errors.length}
            </span>
          )}
        </div>
      )}
      {errors.map((e, i) => (
        <div className="diag-item diag-error" key={i}>
          <i className="fa fa-times-circle" />
          <span>{e.text}</span>
        </div>
      ))}
      {warnings.map((e, i) => (
        <div className="diag-item diag-warn" key={i}>
          <i className="fa fa-exclamation-triangle" />
          <span>{e.text}</span>
        </div>
      ))}
      {notes && <p className="diag-notes">{notes}</p>}
    </aside>
  )
}
